/** Format integer cents as BRL (e.g. 1500 → "R$ 15,00"). */
export function formatBrlCents(cents) {
  if (cents === null || cents === undefined || cents === '') {
    return '—'
  }
  const value = Number(cents)
  if (Number.isNaN(value)) {
    return '—'
  }
  return (value / 100).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })
}

/** Format ISO/date string for display; empty → "—". */
export function formatDateTime(value) {
  if (!value) {
    return '—'
  }
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) {
    return String(value)
  }
  return date.toLocaleString('pt-BR')
}
